export default {"src":"/_next/static/media/gray-kitchen.afd83ec2.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};